import { Button } from "../Button.js";
import { i18n } from "../../../globalization/i18n.js";
import { Component } from "../../Component.js";
import { Text } from "../Text.js";

export class ModalDialog extends Component {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            visible = false,
            title = i18n.t('ui.label.information'),
            buttons = [
                new Button(null, { label: i18n.t('button.close.label'), icon: '#close', onClick: () => { this.close(); }, role: 'cancel' })
            ],
            controls = [],
            style = ''
        } = options;

        this.visible = visible;
        this.title = title;
        this.buttons = buttons.map(b => this.mountControl(b));
        this.controls = controls.map(c => {
            if (typeof c == 'string')
                c = new Text(null, { text: c });
            this.mountControl(c);
            return c;
        });
        this.style = style;

    }

    /**
     * Shows dialog.
     */
    open(options = {}) {

        this.visible = true;
        this.invalidate();

    }

    /**
     * Hides dialog.
     */
    close() {

        if (this.parent)
            return this.hide();

        this.visible = false;
        this.invalidate();

    }

    /**
     * SHows dialog by inserting dialog into parent.
     */
    show(parent) {

        if (!parent) throw new Error('[ModdalDialog] Argument error: "parent" is required.');

        this.visible = true;
        if (this.parent && this.parent !== parent)
            this.hide();
        if (this.parent === parent) {
            this.invalidate();
            return;
        }
        parent.mountControl(this, true);

    }

    /**
     * Hides dialog by removing dialog from parent.
     */
    hide() {

        this.visible = false;
        if (!this.parent)
            return;
        this.parent.unmountControl(this, true);

    }

    getViewHooks() {

        return {
            didMount: focusFocusable,
            //didRedraw: focusFocusable,
        };

        function focusFocusable(vm, data) {
            var focusable = vm.node.el.querySelector('[data-focus=auto]');
            if (focusable) {
                focusable.focus();
            }
        };

    }

    _render(r, vm) {

        const renderer = r;
        const modal = this;

        var modalBody = [],
            overlayCss = '',
            dialogCss = modal.getCss() || '';

        if (modal.controls) {
            modal.controls.forEach(function (control) {
                modalBody.push(control.render(renderer, vm));
            });
        } else {
            modalBody = (function (content) {
                if (!content)
                    return [];
                if (typeof content === 'string')
                    return [content];
                if (typeof content === 'function') {
                    content = content(modal);
                }
                return (Array.isArray(content) ? content : [content]);

            })(modal.content);
        }

        let primaryButtons = (modal.buttons || []).filter((btn) => btn.group != 'secondary'),
            secondaryButtons = (modal.buttons || []).filter((btn) => btn.group == 'secondary');

        if (modal.visible) {
            overlayCss += '.active';
            dialogCss += '.active';
        }

        return renderer.el('div', null, null, [
            renderer.el('div', ['overlay', overlayCss].filter(Boolean).join(' ')),
            renderer.el('dialog', ['dialog', dialogCss].filter(Boolean).join(' '), null, [
                renderer.header({}, [
                    renderer.heading(1, modal.title),
                ]),
                renderer.section({}, modalBody),
                renderer.footer({}, [
                    (
                        (primaryButtons.length + secondaryButtons.length > 0)
                            ? renderer.nav({}, [
                                secondaryButtons.map((btn) => btn.render(renderer, vm)),
                                renderer.spacer(),
                                primaryButtons.map((btn) => btn.render(renderer, vm)),
                            ].flat())
                            : null
                    ),

                ]),
            ]),
        ]);

    }

}
